import styled from 'styled-components';
import { useState } from 'react';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { body2, colors, spacing } from 'ui/theme';
import { GhostButton } from 'ui/button';

const StyledWrapper = styled.div`
  margin-top: ${spacing.half};
`;

const CollapseButton = styled(GhostButton)`
  && {
    color: ${colors.green100};
    display: inline;
    height: auto;
    margin: 0;
    padding: 0;

    &:hover {
      background-color: transparent;
    }
  }
  margin-top: ${spacing.quarter};
`;

const EventsListContainer = styled.ul`
  border: ${spacing.single} solid ${colors.grey25};
  border-radius: ${spacing.half};
  max-height: ${spacing.x12};
  overflow: auto;
  padding: ${spacing.half} ${spacing.base};
`;

const EventsListHeader = styled.p`
  ${body2}
  margin-top: ${spacing.half};
`;

const List = styled.ul`
  padding: 0;
`;

const ListItem = styled.li`
  ${body2}
  list-style: disc inside;
  padding: ${spacing.quarter} 0;
  &:before {
    content: '';
    margin-left: -${spacing.half};
  }
`;

export const BulkActionEventList = ({ eventNames }: { eventNames: string[] }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const numEvents = eventNames.length;

  const n = 5;
  /**
   * To keep the modal from being extremely long, we collapse/hide all events
   * beyond the first 'n' events. If a user does wants to see all events at once,
   * they have the option to do so by clicking the 'Show all events' button.
   */
  const defaultEvents = eventNames.slice(0, n);
  const collapsedEvents = eventNames.slice(n);

  return (
    <StyledWrapper>
      <EventsListHeader>
        Retention period will be updated for <b>{`${numEvents} events`}</b>
      </EventsListHeader>
      <EventsListContainer data-test={'event-list-container'}>
        <List>
          {defaultEvents.map((name) => (
            <ListItem key={name}>{name}</ListItem>
          ))}
        </List>
        <CollapsibleContent isCollapsed={isCollapsed}>
          <List>
            {collapsedEvents.map((name) => (
              <ListItem key={name}>{name}</ListItem>
            ))}
          </List>
        </CollapsibleContent>

        {collapsedEvents.length > 0 && (
          <CollapseButton
            onClick={() => {
              setIsCollapsed(!isCollapsed);
            }}
          >
            {isCollapsed ? `Show all ${numEvents} events` : 'Show less'}
          </CollapseButton>
        )}
      </EventsListContainer>
    </StyledWrapper>
  );
};
